<template>
  <b-row>
    <b-col>
      <p>
        <span style="color: red; margin-left: 10px"><v-icon name="exclamation" scale="0.8" /> Pas de caractères spéciaux
          dans le nom du reclassement de course (+,-,?,...)</span>
      </p>
      <div class="challenge_item" v-for="(rassemblement, index_rassemblement) in rassemblements"
        :key="index_rassemblement">
        <p>
          Nom du Reclassement : {{ rassemblement.nom }} <b-button class="delete_challenge_btn" size="sm"
            @click="deleteRassemblement(index_rassemblement)"><v-icon name="times"></v-icon> Supprimer</b-button>
        </p>
        <p>
          Parcours du reclassement :
          <span v-for="(course, index_course) in rassemblement.courses" :key="index_course"
            class="course_in_challenge">{{ course }}</span>
        </p>
      </div>
      <div class="form_add_challenge">
        <p>
          <b>Créer un reclassement multi-courses (Une course physique séparée en plusieurs sur GMCAP)</b>
        </p>
        <b-row>
          <b-col md="4">
            <b-form-input v-model="temp_rassemblement.nom" size="sm"
              placeholder="Nom du reclassement (optionnel)"></b-form-input>
          </b-col>
          <b-col md="8">
            <p class="container_list_courses_challenge">
              Courses :
              <span v-for="(course, index_course) in temp_rassemblement.courses" :key="index_course"
                class="course_in_challenge">
                {{ course }}
                <b-button @click="removeCourseFromTemp(index_course)"><v-icon name="times"
                    scale="0.5"></v-icon></b-button>
              </span>
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              <b-button size="sm" v-for="(course, index_temp_course) in list_courses" :key="index_temp_course"
                class="course_to_add_challenge" @click="addCourseToRassemblement(index_temp_course)">
                <v-icon name="plus" scale="0.5"></v-icon>
                {{ course }}
              </b-button>
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p style="text-align: right"><b-button size="sm" @click="addTempRassemblement">Ajouter le
                reclassement</b-button></p>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["raw_resultats", "raw_rassemblements"],
  data() {
    return {
      temp_rassemblement: { nom: "", courses: [] },
      rassemblements: [],
    };
  },
  watch: {
    rassemblements() {
      this.$emit("updateRassemblement", this.rassemblements);
    },
  },
  computed: {
    list_courses() {
      var courses = [];
      for (var i = 0; i < this.raw_resultats.length; i++) {
        if (!courses.includes(this.raw_resultats[i]["Course"]) && this.raw_resultats[i]["Course"]) {
          courses.push(this.raw_resultats[i]["Course"]);
        }
      }
      return courses;
    },
  },
  methods: {
    addTempRassemblement() {
      if (this.temp_rassemblement.nom === "") {
        this.temp_rassemblement.nom = "Challenge ";
        for (var i = 0; i < this.temp_rassemblement.courses.length; i++) {
          this.temp_rassemblement.nom += this.temp_rassemblement.courses[i];
          if (i < this.temp_rassemblement.courses.length - 1) {
            this.temp_rassemblement.nom += " - ";
          }
        }
      }
      this.rassemblements.push(JSON.parse(JSON.stringify(this.temp_rassemblement)));
      this.temp_rassemblement.nom = "";
      this.temp_rassemblement.courses = [];
    },
    addCourseToRassemblement(index) {
      this.temp_rassemblement.courses.push(this.list_courses[index]);
    },
    deleteRassemblement(index) {
      this.rassemblements.splice(index, 1);
    },
    removeCourseFromTemp(index) {
      this.temp_rassemblement.courses.splice(index, 1);
    },
  },
  created() {
    if (this.raw_rassemblement.length > 0) {
      this.rassemblement = this.raw_rassemblement;
    }
  },
};
</script>

<style scoped>
.challenge_item,
.form_add_challenge {
  border: 1px solid #999;
  background-color: #e7e7e7;
  padding: 5px;
  margin: 5px 0;
}

.delete_challenge_btn {
  background-color: rgb(109, 4, 4) !important;
  border: 1px solid rgb(109, 4, 4) !important;
  float: right;
}

.delete_challenge_btn:hover {
  background-color: white !important;
  color: rgb(109, 4, 4) !important;
}

.course_in_challenge {
  background-color: #fdfdfd;
  padding: 7px 10px;
  margin: 0 3px;
  border-radius: 3px;
}

.container_list_courses_challenge {
  background-color: white;
  line-height: 23px;
  padding: 5px 8px 3px 8px;
  border-radius: 3px;
  border: 1px solid #ced4da;
}

.container_list_courses_challenge .course_in_challenge {
  background-color: #e2e2e2;
  padding-right: 0 !important;
}

.course_in_challenge button {
  background-color: rgb(109, 4, 4) !important;
  border: none !important;
  padding: 2px 5px;
  margin-top: -2px;
}

.course_to_add_challenge {
  color: black !important;
  background-color: rgb(173, 243, 173) !important;
  border: 1px solid rgb(173, 243, 173) !important;
  font-size: 13px;
  margin: 0px 3px;
}
</style>